<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn th-btn-normal"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ 'common.edit' | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.marketing.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content">
        <td class="th-plugin-line--data" *ngFor="let message of messages">
          <span>{{ message }}</span>
        </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div class="ir-plugin-values th-plugin-values margin-big" *ngIf="description">
      <p class="ir-pv3">
        <span innerHtml="{{ description }}"></span>
      </p>
    </div>
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--header">
        <td colspan="4">
          <span>{{ 'plugins.marketing.presentations-list' | translate }}</span>
        </td>
      </tr>
    </table>
    <div class="ir-item-line">
      <div class="ir-item-cell s8 strong">
        <span>{{ 'common.name' | translate }}</span>
      </div>
      <div class="ir-item-cell s2 right strong statut">
        <span class="important">
          {{ 'plugins.marketing.link' | translate }}
        </span>
      </div>
    </div>
    <div *ngIf="links">
      <div class="ir-item-line th-section-dark" *ngFor="let item of links">
        <div class="ir-item-cell s8 strong">
          <span>{{ item.Description }}</span>
        </div>
        <div class="ir-item-cell s2 right strong statut">
          <span class="important clickable" (click)="navigateTo(item.Url)">
            {{ 'common.view' | translate }}
            <i class="material-icons warning">link</i>
          </span>
        </div>
      </div>
    </div>
  </div>
</div>
